"use strict";

// this should only be used on html generated by me
// using generateEmail or generateEmailMultiple
function removeHTML(str) {
  var new_str = str;
  new_str = new_str.replace(/<br\/>/g, '\n');
  new_str = new_str.replace(/<[ A-Za-z":;=/]*>/g, '');
  var map = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#039;': '\''
  };
  new_str = new_str.replace(/&[ampltgquo#039]{2,};/g, function (m) {
    return map[m];
  });
  return new_str;
}

module.exports = removeHTML;